var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-rblock",staticStyle:{"background-color":"#fff"}},[_vm._v(_vm._s(_vm.$t(_vm.data.title || _vm.data.label)))])
}
var staticRenderFns = []

export { render, staticRenderFns }